// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"974da385","488":"ca2cefbe","977":"4ad0f1de"}[chunkId] + ".chunk.js";
};